module.exports = __webpack_public_path__ + "img/arboedu_white_icon.d0a620a5.png";